<template>
  <div id="market information">
    <Head/>
    
    <Foot/>
  </div>
</template>
<script>
import Head from "../components/Head";
import Foot from "../components/Foot";
export default {
  name: "ContactUs",
  data(){
    return {
      
    };
  },
  components: {
    Head,
    Foot
  }
};
</script>
<style lang="less" scoped>
  
</style>